import { useState } from "react";

import { NotificationExpandToggle } from "./NotificationExpandToggle";
import { Column, Row, Text } from "@/components";

import { dates } from "@/lib/dates";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { getCandidacyLink } from "@/lib/notificationLinks";
import { cn } from "@/lib/utils";
import { NotificationInterviewsTodayPayload, NotificationType } from "@/types";

export const NotificationInterviewsTodayList = ({
  isCompact = false,
  payload,
  trackingSurface,
}: {
  isCompact?: boolean;
  payload: NotificationInterviewsTodayPayload;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { interviews } = payload;

  const render = () => (
    <Column className="gap-0.5">
      <NotificationExpandToggle
        isExpanded={isExpanded}
        notificationType={NotificationType.INTERVIEWS_TODAY}
        setIsExpanded={setIsExpanded}
        trackingSurface={trackingSurface}
      >
        {interviews.length}{" "}
        {interviews.length === 1 ? "interview" : "interviews"}
      </NotificationExpandToggle>
      {isExpanded ? (
        <Column className="gap-1 border-l border-slate-200 pl-3 pt-1">
          {interviews.map((interview) => (
            <Column
              key={interview.candidacyId}
              className="cursor-pointer gap-0 rounded-md px-2 py-1.5 hover:bg-slate-50"
              onClick={(e) => {
                e.stopPropagation();
                mixpanelUtils.trackRowClick(
                  "Notification list item",
                  MIXPANEL_SCREENS.NOTIFICATIONS,
                  {
                    notification_type: NotificationType.INTERVIEWS_TODAY,
                    surface: trackingSurface,
                  },
                );
                window.open(getCandidacyLink(interview), "_blank");
              }}
            >
              <Row className="items-center gap-1.5">
                <Text className={cn("text-sm", isCompact && "text-xs")}>
                  {interview.candidateName}
                </Text>
                <Text className="text-xs font-normal text-slate-500">
                  {dates.formatTime(interview.dateTime)}
                </Text>
              </Row>
              <Text className="text-xs font-normal text-slate-500">
                {interview.customerName} &middot; {interview.reqTitle}
              </Text>
            </Column>
          ))}
        </Column>
      ) : null}
    </Column>
  );

  return render();
};
